/**
 * Majlis Mart - product page engine
 * Variant switching, price/stock sync, gallery (thumbs + swipe + zoom), AJAX add to cart, sticky buy bar.
 */
(function () {
  'use strict';

  var T = window.theme || {};
  var IS_RTL = document.documentElement.dir === 'rtl';
  var ADD_ERROR = (T.strings && T.strings.addError) || 'Could not add this item to your cart.';

  // ---- Money formatting (mirrors Shopify's format strings so JS matches server-rendered prices) ----
  function fmt(cents, precision, thousands, decimal) {
    var parts = (cents / 100).toFixed(precision).split('.');
    var whole = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
    return parts[1] ? whole + decimal + parts[1] : whole;
  }

  function money(cents, withCurrency) {
    var format = (withCurrency && T.moneyWithCurrencyFormat) || T.moneyFormat || '{{amount}} AED';
    cents = Number(cents) || 0;
    var m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!m) return format;
    var v;
    switch (m[1]) {
      case 'amount_no_decimals': v = fmt(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': v = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = fmt(cents, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': v = fmt(cents, 0, ' ', '.'); break;
      case 'amount_with_space_separator': v = fmt(cents, 2, ' ', ','); break;
      default: v = fmt(cents, 2, ',', '.');
    }
    return format.replace(m[0], v);
  }

  // Same markup as snippets/price.liquid so the price never changes look after a variant switch
  function priceHtml(v) {
    var withCur = !!T.currencyCodeEnabled;
    var price = money(v.price, withCur);
    var onSale = v.compare_at_price && v.compare_at_price > v.price;
    var cls = 'price flex flex-wrap items-baseline gap-2' + (!v.available ? ' price--sold-out' : '') + (onSale ? ' price--on-sale' : '');
    var saleLabel = IS_RTL ? 'السعر بعد الخصم' : 'Sale price';
    var regLabel = IS_RTL ? 'السعر الأصلي' : 'Regular price';
    var priceCls = 'text-xl md:text-2xl font-bold text-stone-900 tracking-tight';
    var inner;
    if (onSale) {
      inner = '<div class="price__sale flex items-baseline gap-2">' +
        '<span class="sr-only">' + saleLabel + '</span><span class="' + priceCls + '">' + price + '</span>' +
        '<span class="sr-only">' + regLabel + '</span><s class="text-sm md:text-base font-normal text-stone-600 line-through">' + money(v.compare_at_price, withCur) + '</s></div>';
    } else {
      inner = '<div class="price__regular"><span class="sr-only">' + regLabel + '</span><span class="' + priceCls + '">' + price + '</span></div>';
    }
    var badge = '';
    if (onSale && v.available) {
      var off = Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price);
      badge = '<span class="inline-flex items-center px-2 py-0.5 rounded text-xs font-semibold bg-rose-50 text-rose-700 border border-rose-200">-' + off + '%</span>';
    } else if (!v.available) {
      badge = '<span class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-stone-100 text-stone-600 border border-stone-200">' + (T.strings && T.strings.soldOut || 'Sold Out') + '</span>';
    }
    return '<div class="' + cls + '"><div class="price__container flex items-baseline gap-2">' + inner + '</div>' + badge + '</div>';
  }

  document.addEventListener('DOMContentLoaded', function () {
    var section = document.querySelector('[data-section-type="main-product"]');
    if (!section) return;
    var form = section.querySelector('[data-product-form]');
    if (!form) return;

    var productId = section.dataset.productId;
    var jsonEl = document.getElementById('ProductJson-' + productId);
    if (!jsonEl) return;
    var product;
    try { product = JSON.parse(jsonEl.textContent); } catch (e) { console.error('Invalid product JSON', e); return; }

    var variantInput = form.querySelector('[data-selected-variant-id]');
    var addBtn = form.querySelector('[data-add-to-cart-btn]');
    var addText = form.querySelector('[data-add-to-cart-text]');
    var priceBox = document.getElementById('ProductPriceContainer');
    var stockBox = section.querySelector('[data-stock-indicator]');
    var payWrap = form.querySelector('[data-shopify-payment-btn-wrapper]');
    var qtyInput = section.querySelector('[data-qty-input]');
    var stickyBar = section.querySelector('[data-sticky-mobile-bar]');
    var stickyPrice = section.querySelector('[data-sticky-price]');
    var stickyAdd = section.querySelector('[data-sticky-add-btn]');
    var stickyBuy = section.querySelector('[data-sticky-buy-btn]');

    // ---------- Variant engine ----------
    function selectedOptions() {
      var out = [];
      var count = product.options ? product.options.length : 0;
      for (var i = 1; i <= count; i++) {
        var checked = form.querySelector('[data-single-option-selector][data-index="option' + i + '"]:checked');
        if (checked) { out.push(checked.value); continue; }
        var sel = form.querySelector('select[data-index="option' + i + '"]');
        if (sel) out.push(sel.value);
      }
      return out;
    }

    function refreshOptionStates(selected) {
      form.querySelectorAll('.mm-option-pill').forEach(function (label) {
        var input = label.querySelector('[data-single-option-selector]');
        if (!input) return;
        var idx = parseInt(String(input.dataset.index).replace('option', ''), 10) - 1;
        var probe = selected.slice();
        probe[idx] = input.value;
        var ok = product.variants.some(function (v) {
          return v.available && probe.every(function (val, i) { return !val || v.options[i] === val; });
        });
        label.classList.toggle('is-unavailable', !ok);
        label.classList.toggle('is-selected', input.checked);
      });
    }

    function setPurchasable(ok, label) {
      if (addBtn) addBtn.disabled = !ok;
      if (addText && label) addText.textContent = label;
      if (stickyAdd) stickyAdd.disabled = !ok;
      if (stickyBuy) stickyBuy.disabled = !ok;
      if (payWrap) payWrap.style.display = ok ? '' : 'none';
    }

    function setStock(available, unavailableLabel) {
      if (!stockBox) return;
      var dot = stockBox.querySelector(':scope > span');
      var strong = stockBox.querySelector('strong');
      var small = stockBox.querySelector('small');
      if (dot) dot.classList.toggle('is-live', available);
      if (strong) strong.textContent = available ? (IS_RTL ? 'متوفر الآن' : 'In stock') : (unavailableLabel || (IS_RTL ? 'غير متوفر حالياً' : 'Currently unavailable'));
      if (small) small.hidden = !available;
    }

    function applyVariant(variant) {
      if (!variant) {
        setPurchasable(false, T.strings && T.strings.unavailable || 'Unavailable');
        setStock(false, T.strings && T.strings.unavailable);
        return;
      }
      if (variantInput) variantInput.value = variant.id;
      if (priceBox) priceBox.innerHTML = priceHtml(variant);
      if (stickyPrice) stickyPrice.textContent = money(variant.price, !!T.currencyCodeEnabled);
      setStock(variant.available);
      setPurchasable(variant.available, variant.available ? (T.strings && T.strings.addToCart || 'Add to Cart') : (T.strings && T.strings.soldOut || 'Sold Out'));

      if (variant.featured_media && variant.featured_media.id) {
        showMedia(variant.featured_media.id);
      }

      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({ path: url.toString() }, '', url.toString());
      }

      document.querySelectorAll('[data-whatsapp-order-btn]').forEach(function (btn) {
        btn.dataset.variantTitle = variant.title;
        btn.dataset.variantId = variant.id;
        btn.dataset.price = variant.price;
      });

      document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: variant } }));
    }

    form.querySelectorAll('[data-single-option-selector]').forEach(function (input) {
      input.addEventListener('change', function () {
        var selected = selectedOptions();
        form.querySelectorAll('[data-option-selected-val]').forEach(function (el) {
          var i = parseInt(el.dataset.optionSelectedVal, 10) - 1;
          if (selected[i]) el.textContent = selected[i];
        });
        var match = product.variants.find(function (v) {
          return selected.every(function (opt, i) { return v.options[i] === opt; });
        });
        refreshOptionStates(selected);
        applyVariant(match);
      });
    });
    refreshOptionStates(selectedOptions());

    // ---------- Add to cart ----------
    function showError(msg) {
      var box = document.getElementById('ProductErrorBanner');
      if (!box) {
        box = document.createElement('div');
        box.id = 'ProductErrorBanner';
        box.setAttribute('role', 'alert');
        box.className = 'p-3 mt-3 rounded-lg bg-red-50 border border-red-200 text-red-800 text-xs font-medium';
        form.appendChild(box);
      }
      box.textContent = msg;
      box.style.display = 'block';
      clearTimeout(box._t);
      box._t = setTimeout(function () { box.style.display = 'none'; }, 5000);
    }

    function addToCart(btn) {
      if (!btn || btn.disabled) return Promise.resolve();
      var id = variantInput ? variantInput.value : null;
      if (!id) return Promise.resolve();
      var qty = Math.max(1, qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1);
      var original = addText ? addText.textContent : '';

      btn.disabled = true;
      btn.classList.add('opacity-75', 'pointer-events-none');
      if (addText) addText.textContent = T.strings && T.strings.adding || 'Adding...';

      return fetch((T.routes && T.routes.cartAdd || '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: id, quantity: qty })
      }).then(function (res) {
        return res.json().then(function (data) { return { ok: res.ok, data: data }; });
      }).then(function (r) {
        if (r.ok) {
          if (window.CartDrawer && typeof window.CartDrawer.refresh === 'function') {
            return Promise.resolve(window.CartDrawer.refresh()).then(function () { window.CartDrawer.open(); });
          }
          window.location.href = T.routes && T.routes.cart || '/cart';
        } else {
          showError(r.data.description || r.data.message || ADD_ERROR);
        }
      }).catch(function (err) {
        console.error('Add to cart failed', err);
        showError(IS_RTL ? 'حدث خطأ في الاتصال. حاول مرة أخرى.' : 'Network error. Please try again.');
      }).then(function () {
        btn.classList.remove('opacity-75', 'pointer-events-none');
        if (addText) addText.textContent = original;
        var current = product.variants.find(function (v) { return String(v.id) === String(variantInput && variantInput.value); });
        var ok = current ? current.available : true;
        if (addBtn) addBtn.disabled = !ok;
        if (stickyAdd) stickyAdd.disabled = !ok;
      });
    }

    if (addBtn) addBtn.addEventListener('click', function (e) { e.preventDefault(); addToCart(addBtn); });

    // ---------- Quantity ----------
    function setQty(n) {
      if (!qtyInput) return;
      qtyInput.value = Math.min(99, Math.max(1, n));
      qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
    }
    var minus = section.querySelector('[data-qty-minus]');
    var plus = section.querySelector('[data-qty-plus]');
    if (minus) minus.addEventListener('click', function () { setQty((parseInt(qtyInput.value, 10) || 1) - 1); });
    if (plus) plus.addEventListener('click', function () { setQty((parseInt(qtyInput.value, 10) || 1) + 1); });
    if (qtyInput) qtyInput.addEventListener('change', function () { setQty(parseInt(qtyInput.value, 10) || 1); });

    // ---------- Gallery ----------
    var mediaItems = Array.prototype.slice.call(section.querySelectorAll('.mm-product-media'));
    var thumbs = Array.prototype.slice.call(section.querySelectorAll('[data-thumbnail-media-id]'));

    function currentIndex() {
      for (var i = 0; i < mediaItems.length; i++) if (!mediaItems[i].classList.contains('is-hidden')) return i;
      return 0;
    }

    function showMedia(id) {
      var found = false;
      mediaItems.forEach(function (m) {
        var match = String(m.dataset.mediaId) === String(id);
        if (match) found = true;
        m.classList.toggle('is-hidden', !match);
        m.style.display = '';
        if (!match) m.querySelectorAll('video').forEach(function (v) { v.pause(); });
      });
      if (!found) return;
      thumbs.forEach(function (t) {
        var active = String(t.dataset.thumbnailMediaId) === String(id);
        t.classList.toggle('is-active', active);
        if (active) {
          t.setAttribute('aria-current', 'true');
          var c = t.parentElement;
          if (c && c.scrollWidth > c.clientWidth) {
            c.scrollTo({ left: t.offsetLeft - c.clientWidth / 2 + t.clientWidth / 2, behavior: 'smooth' });
          }
        } else {
          t.removeAttribute('aria-current');
        }
      });
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { showMedia(t.dataset.thumbnailMediaId); });
    });

    function step(dir) {
      var next = Math.min(mediaItems.length - 1, Math.max(0, currentIndex() + dir));
      if (mediaItems[next]) showMedia(mediaItems[next].dataset.mediaId);
    }

    var stage = section.querySelector('.mm-product-media-stage');
    if (stage && mediaItems.length > 1) {
      var startX = null;
      stage.addEventListener('touchstart', function (e) {
        startX = e.target.closest('video,iframe,model-viewer') ? null : e.touches[0].clientX;
      }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        startX = null;
        if (Math.abs(dx) < 50) return;
        var forward = IS_RTL ? dx > 0 : dx < 0;
        step(forward ? 1 : -1);
      }, { passive: true });
    }

    // ---------- Zoom ----------
    var zoomTrigger = section.querySelector('[data-product-zoom-trigger]');
    var zoomModal = document.getElementById('ProductZoomModal');
    var zoomImage = document.getElementById('ZoomModalImage');

    if (zoomTrigger && zoomModal && zoomImage) {
      var openZoom = function () {
        var img = section.querySelector('.mm-product-media:not(.is-hidden) img');
        if (!img) return;
        zoomImage.src = img.src;
        zoomImage.alt = img.alt || '';
        zoomModal.classList.add('is-active');
        document.body.classList.add('drawer-open');
        var closeBtn = zoomModal.querySelector('[data-zoom-close]');
        if (closeBtn) closeBtn.focus();
      };
      var closeZoom = function () {
        if (!zoomModal.classList.contains('is-active')) return;
        zoomModal.classList.remove('is-active');
        document.body.classList.remove('drawer-open');
        zoomTrigger.focus();
      };
      zoomTrigger.addEventListener('click', openZoom);
      zoomModal.querySelectorAll('[data-zoom-close]').forEach(function (b) { b.addEventListener('click', closeZoom); });
      zoomModal.addEventListener('click', function (e) { if (e.target === zoomModal) closeZoom(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeZoom(); });
    }

    // ---------- Sticky buy bar ----------
    if (stickyBar) {
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          var e = entries[0];
          stickyBar.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
        }).observe(form);
      } else {
        stickyBar.classList.add('is-visible');
      }

      if (stickyAdd) stickyAdd.addEventListener('click', function () { addToCart(stickyAdd); });

      if (stickyBuy) {
        stickyBuy.addEventListener('click', function () {
          var target = payWrap || form;
          target.scrollIntoView({ behavior: 'smooth', block: 'center' });
          var native = payWrap && payWrap.querySelector('button, [role="button"]');
          if (native) native.focus({ preventScroll: true });
        });
      }
    }
  });
})();
